import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBERSHIP_IOS_AMOUNTS_ENABLED_FOR = createFcmConfig('membership_ios_amounts_enabled_for', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
